'use client';

import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { AgentDetail } from "./AgentDetail";
import type { IAgent } from "@/lib/types";

interface AgentModalProps {
    agent: IAgent | null;
    isOpen: boolean;
    onClose: () => void;
}

export function AgentModal({ agent, isOpen, onClose }: AgentModalProps) {
    if (!agent) return null;

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="max-w-4xl w-[calc(100%-2rem)] p-0 border-none bg-transparent shadow-none overflow-hidden sm:rounded-[2.5rem] max-h-[85vh] flex flex-col">
                <DialogHeader className="sr-only">
                    <DialogTitle>Agent Profile: {agent.name}</DialogTitle>
                </DialogHeader>
                <div className="flex-1 bg-background/90 backdrop-blur-3xl rounded-[2.5rem] overflow-y-auto shadow-[0_32px_64px_-15px_rgba(0,0,0,0.5)] border border-white/20 custom-scrollbar">
                    <AgentDetail agent={agent} isModal={true} />
                </div>
            </DialogContent>
        </Dialog>
    );
}
